/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Trainingfinishedat2Inputs */

const de__field_trainingfinishedat2 = /** @type {(inputs: _Field_Trainingfinishedat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training fertiggestellt am`)
};

/**

* @param {_Field_Trainingfinishedat2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_trainingfinishedat2 = /** @type {((inputs?: _Field_Trainingfinishedat2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Trainingfinishedat2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_trainingfinishedat2(inputs)
});
export { _field_trainingfinishedat2 as "_field_trainingFinishedAt" }